import type { FormDescriptor, PayloadBuilderId } from '@finance/contracts';

export interface PayloadFieldBinding {
  sourceFields: string[];
}

export interface PayloadBuildResult {
  payload: Record<string, unknown>;
  provenance?: Record<string, string[]>;
}

export interface PayloadBuilder {
  id: PayloadBuilderId;
  build?: (values: Record<string, unknown>, descriptor: FormDescriptor) => Record<string, unknown>;
  buildWithProvenance?: (values: Record<string, unknown>, descriptor: FormDescriptor) => PayloadBuildResult;
  fieldBindings?: Record<string, PayloadFieldBinding>;
}

const payloadBuilders = new Map<string, PayloadBuilder>();

export function registerPayloadBuilder(builder: PayloadBuilder): void {
  payloadBuilders.set(builder.id as string, builder);
}

export function getPayloadBuilder(id: PayloadBuilderId): PayloadBuilder | undefined {
  return payloadBuilders.get(id as string);
}

export function hasPayloadBuilder(id: PayloadBuilderId): boolean {
  return payloadBuilders.has(id as string);
}
